// Auto-generated translation for el.
// Source: kennisbank.js, translated via Claude Sonnet on 2026-05-26T11:17:13.291679+00:00.

export const KENNISBANK = {
  "paarden-gezondheid": {
    slug: "paarden-gezondheid",
    category: "Υγεία",
    title: "Υγεία αλόγου — πλήρης οδηγός",
    lead: "Η υγεία του αλόγου ξεκινά με καλή παρατήρηση, συστηματική τήρηση αρχείου και έγκαιρη επικοινωνία με επαγγελματίες. Σε αυτόν τον οδηγό εξηγούμε τις βασικές αρχές: καθημερινά σημάδια, έλεγχοι, πρόληψη και πότε να καλέσετε τον κτηνίατρο.",
    datePublished: "2026-05-01",
    sections: [
      {
        h: "Τι είναι η υγεία του αλόγου;",
        p: "Η υγεία του αλόγου είναι κάτι περισσότερο από το «να μην είναι άρρωστο». Αφορά ένα καλά λειτουργούν κινητικό σύστημα, υγιές πεπτικό, ψυχική ισορροπία και τακτική προληπτική φροντίδα. Το EquiSight υποστηρίζει όλους αυτούς τους πυλώνες σε ένα ενιαίο αρχείο ανά άλογο.",
      },
      {
        h: "Καθημερινά σημάδια",
        list: [
          "Όρεξη και κατανάλωση νερού",
          "Συμπεριφορά στο στάβλο και στο βοσκοτόπι",
          "Κόπρανα (σύσταση, συχνότητα)",
          "Στάση σώματος και κίνηση",
          "Τρίχωμα και κατάσταση δέρματος",
          "Καρδιακός ρυθμός και αναπνοή σε ηρεμία",
        ],
      },
      {
        h: "Προληπτική διαχείριση",
        p: "Η καλή υγεία του αλόγου βασίζεται σε μεγάλο βαθμό στην πρόληψη. Παρακολουθείτε συστηματικά εμβολιασμούς, απαράσιτωση, οδοντικούς ελέγχους και φροντίδα οπλών. Το EquiSight στέλνει αυτόματα υπενθυμίσεις.",
      },
      {
        h: "Πότε να καλέσετε τον κτηνίατρο;",
        list: [
          "Άρνηση φαγητού ή νερού (>4 ώρες)",
          "Συμπτώματα κολικού",
          "Αιφνίδια χωλότητα",
          "Υψηλός πυρετός (>38,5°C)",
          "Τραύματα που δεν σταματούν να αιμορραγούν",
          "Προβλήματα κατά τον τοκετό",
        ],
      },
    ],
    faq: [
      {
        q: "Πόσο συχνά πρέπει να επισκέπτεται το άλογο τον οδοντίατρο;",
        a: "Μία φορά το χρόνο για ενήλικα άλογα. Νεαρά άλογα (3–5 ετών) και ηλικιωμένα χρειάζονται συχνότερους ελέγχους.",
      },
      {
        q: "Ποιοι εμβολιασμοί είναι υποχρεωτικοί;",
        a: "Για αγώνες KNHS είναι υποχρεωτικός ο εμβολιασμός κατά της γρίπης σύμφωνα με το προβλεπόμενο πρόγραμμα. Ο εμβολιασμός κατά του τετάνου συνιστάται ανεπιφύλακτα.",
      },
    ],
    related: [
      "entingen",
      "voeradvies",
      "hoefverzorging",
    ],
  },
  "voeradvies": {
    slug: "voeradvies",
    category: "Διατροφή",
    title: "Συμβουλές διατροφής αλόγου — βασικοί κανόνες και παγίδες",
    lead: "Η σωστή διατροφή είναι η βάση της υγείας του αλόγου. Σε αυτόν τον οδηγό: χόρτο, συμπυκνωμένες τροφές, συμπληρώματα, βάρος και ο δείκτης φρουκτάνης εξηγημένος.",
    datePublished: "2026-05-02",
    sections: [
      {
        h: "Πόσο χόρτο χρειάζεται ένα άλογο;",
        p: "Ένα μέσο άλογο χρειάζεται χονδροειδείς τροφές (χόρτο/σιλάζ) σε ποσότητα 1,5–2% του σωματικού του βάρους την ημέρα. Για ένα άλογο 500kg αυτό αντιστοιχεί σε 7,5–10kg χόρτο.",
      },
      {
        h: "Συμπυκνωμένες τροφές — πότε χρειάζονται;",
        p: "Οι συμπυκνωμένες τροφές είναι απαραίτητες μόνο σε περιπτώσεις εντατικής εργασίας, κύησης, γαλουχίας ή ιδιαίτερων ενεργειακών αναγκών. Πολλά άλογα λαμβάνουν συμπυκνωμένες τροφές χωρίς να τις χρειάζονται, κάτι που οδηγεί σε υπέρβαρο και μεταβολικά προβλήματα.",
      },
      {
        h: "Συμπληρώματα",
        list: [
          "Αλάτι/μέταλλα (ελεύθερη πρόσβαση)",
          "Μαγνήσιο για στρες / μύες",
          "Βιοτίνη για προβλήματα οπλών",
          "Γλυκοζαμίνη για αρθρώσεις",
        ],
      },
      {
        h: "Δείκτης φρουκτάνης — προσοχή με το γρασίδι",
        p: "Ιδιαίτερα το πρωί την άνοιξη και κατά τις κρύες νύχτες με ηλιόλουστες μέρες, η περιεκτικότητα σε φρουκτάνη στο γρασίδι είναι υψηλή. Αποτελεί κίνδυνο για χτύπημα οπλών (laminitis). Το EquiSight ειδοποιεί αυτόματα.",
      },
    ],
    faq: [
      {
        q: "Πρέπει να δίνω πάντα συμπυκνωμένες τροφές;",
        a: "Όχι. Πολλά άλογα αρκούνται σε καλές χονδροειδείς τροφές και ένα συμπλήρωμα μετάλλων. Συμπυκνωμένες τροφές μόνο όταν υπάρχουν αυξημένες ενεργειακές ανάγκες.",
      },
      {
        q: "Πώς μπορώ να ξέρω αν το άλογό μου είναι υπέρβαρο;",
        a: "Μέσω της βαθμολογίας κατάστασης σώματος (BCS) και μεζούρας. Το EquiSight σας βοηθά να το παρακολουθείτε και παρέχει προειδοποιήσεις για τάσεις.",
      },
    ],
    related: [
      "fructaan-index",
      "paarden-gezondheid",
    ],
  },
  "hoefverzorging": {
    slug: "hoefverzorging",
    category: "Φροντίδα Οπλών",
    title: "Φροντίδα οπλών αλόγου — όλα όσα πρέπει να γνωρίζεις",
    lead: "Χωρίς υγιή οπλή, δεν υπάρχει άλογο. Η φροντίδα των οπλών απαιτεί συνέπεια: κλάδεμα ή πέταλο, τακτικός έλεγχος, στεγνός στάβλος και σωστή διατροφή.",
    datePublished: "2026-05-03",
    sections: [
      {
        h: "Πόσο συχνά πρέπει να έρχεται ο πεταλωτής;",
        p: "Κατά μέσο όρο κάθε 6–8 εβδομάδες. Με πέταλο λίγο πιο συχνά, χωρίς πέταλο μπορεί μερικές φορές να μεσολαβεί περισσότερος χρόνος. Διατήρησε τακτικό πρόγραμμα — το EquiSight στέλνει αυτόματες υπενθυμίσεις.",
      },
      {
        h: "Πέταλο ή γυμνή οπλή;",
        p: "Και οι δύο επιλογές μπορεί να λειτουργούν καλά, ανάλογα με το άλογο, τον κλάδο ιππασίας και τις συνθήκες του στάβλου ή του λιβαδιού. Συμβουλέψου τον πεταλωτή σου.",
      },
      {
        h: "Σημάδια προβλημάτων οπλής",
        list: [
          "Ανώμαλο βάδισμα",
          "Σφύξη στις αρτηρίες της οπλής",
          "Θερμότητα στην οπλή",
          "Ρωγμές ή θρυμματισμός",
          "Δύσοσμη σήψη βολίδας",
        ],
      },
    ],
    faq: [
      {
        q: "Τι κάνει ακριβώς ένας πεταλωτής;",
        a: "Κλαδεύει την οπλή (τη διορθώνει και την λειαίνει), προσαρμόζει ή τοποθετεί νέα πέταλα όπου χρειάζεται, και αξιολογεί τη συνολική υγεία της οπλής.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "entingen": {
    slug: "entingen",
    category: "Υγεία",
    title: "Εμβολιασμοί αλόγου — πρόγραμμα, τύποι και κανόνες",
    lead: "Ποιους εμβολιασμούς χρειάζεται ένα άλογο; Γρίπη, τέτανος, ρινοπνευμονία και ιός Δυτικού Νείλου. Προγράμματα και κανόνες KNHS με μια ματιά.",
    datePublished: "2026-05-04",
    sections: [
      {
        h: "Γρίπη",
        p: "Πρώτη σειρά 3 εμβολιασμών (εβδομάδα 0, 4, 6 μήνες), στη συνέχεια ετησίως. Υποχρεωτικό για αγώνες KNHS και ο τελευταίος εμβολιασμός να μην υπερβαίνει τους 6 μήνες.",
      },
      {
        h: "Τέτανος",
        p: "Πρώτη σειρά 2 εμβολιασμών (εβδομάδα 0 και 4 εβδομάδες), στη συνέχεια κάθε 2–3 χρόνια. Συνιστάται ανεπιφύλακτα για κάθε άλογο.",
      },
      {
        h: "Ρινοπνευμονία (EHV-1/4)",
        p: "Ιδιαίτερα σε σταύλους με πολλά άλογα και σε έγκυες φοράδες. Κάθε 6 μήνες.",
      },
      {
        h: "Ιός Δυτικού Νείλου",
        p: "Συνιστάται σε περιοχές υψηλού κινδύνου. Ετησίως, πριν από την εποχή των κουνουπιών.",
      },
    ],
    faq: [
      {
        q: "Τι γίνεται αν ο εμβολιασμός του αλόγου μου έχει καθυστερήσει;",
        a: "Στη γρίπη συχνά πρέπει να ξεκινήσετε εκ νέου τη βασική σειρά. Το EquiSight σας ειδοποιεί εγκαίρως.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "fructaan-index": {
    slug: "fructaan-index",
    category: "Διατροφή",
    title: "Δείκτης φρουκτάνης αλόγου — τι είναι και πώς τον χρησιμοποιείς",
    lead: "Τι είναι ο δείκτης φρουκτάνης; Πότε είναι το γρασίδι επικίνδυνο για το άλογό σου; Πώς να αποτρέψεις τη χαλίνωση με δεδομένα και προγραμματισμό.",
    datePublished: "2026-05-05",
    sections: [
      {
        h: "Τι είναι η φρουκτάνη;",
        p: "Η φρουκτάνη είναι ένα σάκχαρο που αποθηκεύει το γρασίδι. Σε υψηλές συγκεντρώσεις μπορεί να οδηγήσει σε ζύμωση στο παχύ έντερο και κατά συνέπεια σε χαλίνωση (laminitis).",
      },
      {
        h: "Πότε είναι υψηλή η φρουκτάνη;",
        list: [
          "Κρύες νύχτες + ηλιόλουστες μέρες (άνοιξη, φθινόπωρο)",
          "Νωρίς το πρωί",
          "Μετά από παγετό τη νύχτα",
          "Γρασίδι υπό στρες (μετά από κόψιμο, ξηρασία, κοντό)",
        ],
      },
      {
        h: "Πώς το παρακολουθείς;",
        p: "Το EquiSight υπολογίζει τον δείκτη φρουκτάνης ανά βοσκότοπο και προειδοποιεί σε υψηλό κίνδυνο. Συνδύασέ το με τις ώρες βοσκής για βέλτιστη διαχείριση.",
      },
    ],
    faq: [
      {
        q: "Ποια άλογα διατρέχουν μεγαλύτερο κίνδυνο;",
        a: "Τα πόνυ (ιδιαίτερα Shetland και Welsh), τα υπέρβαρα άλογα, τα άλογα με EMS και σύνδρομο Cushing, καθώς και άλογα που έχουν εμφανίσει χαλίνωση στο παρελθόν.",
      },
    ],
    related: [
      "voeradvies",
      "paarden-gezondheid",
    ],
  },
  "koliek": {
    slug: "koliek",
    category: "Παθήσεις",
    title: "Κολικός αλόγου — συμπτώματα, αιτίες & τι να κάνετε",
    lead: "Ο κολικός είναι κοιλιακός πόνος. Στα άλογα είναι πάντα σοβαρός — καλέστε αμέσως τον κτηνίατρο σε περίπτωση αμφιβολίας. Διαβάστε εδώ για συμπτώματα, αιτίες και πρώτες βοήθειες.",
    datePublished: "2026-05-06",
    sections: [
      {
        h: "Συμπτώματα",
        list: [
          "Δεν τρώει ή δεν πίνει",
          "Ανησυχία, σκάβει στο έδαφος",
          "Ξαπλώνει και ξανασηκώνεται",
          "Κοιτάζει ή κλωτσά την κοιλιά του",
          "Εφίδρωση χωρίς κόπωση",
          "Αυξημένος καρδιακός ρυθμός (>48/λεπτό)",
        ],
      },
      {
        h: "Αιτίες",
        list: [
          "Αλλαγές στη διατροφή",
          "Ανεπαρκής κατανάλωση νερού (ιδιαίτερα τον χειμώνα)",
          "Υπερβολική ποσότητα συμπυκνωμένης τροφής",
          "Κατάποση άμμου",
          "Στρες",
          "Μόλυνση από παράσιτα",
        ],
      },
      {
        h: "Τι να κάνετε;",
        p: "Καλέστε αμέσως τον κτηνίατρο. Μην αφήνετε το άλογο να κυλιέται αν έχει σοβαρό κολικό. Περπατήστε ήρεμα αν είναι εφικτό. Αποφύγετε να δώσετε τροφή ή νερό μέχρι να φτάσει ο κτηνίατρος.",
      },
    ],
    faq: [
      {
        q: "Μπορώ να προλάβω τον κολικό;",
        a: "Εν μέρει: σταθερή χονδροειδής τροφή, επαρκές νερό, επαρκής κίνηση, τακτική απαλλαγή από παράσιτα και αποφυγή απότομων αλλαγών στη διατροφή.",
      },
    ],
    related: [
      "paarden-gezondheid",
      "voeradvies",
    ],
  },
  "droes": {
    slug: "droes",
    category: "Παθήσεις",
    title: "Στραγγάλωμα αλόγου — συμπτώματα, μετάδοση & απομόνωση",
    lead: "Το στραγγάλωμα (strangles) είναι εξαιρετικά μεταδοτικό. Η έγκαιρη αναγνώριση και απομόνωση είναι κρίσιμες για την αποφυγή εξάπλωσης στο στάβλο.",
    datePublished: "2026-05-07",
    sections: [
      {
        h: "Συμπτώματα",
        list: [
          "Πυρετός (>39°C)",
          "Έλλειψη όρεξης",
          "Οιδήματα κάτω από τη γνάθο",
          "Πυώδης ρινική έκκριση",
          "Αποστήματα που σπάνε",
        ],
      },
      {
        h: "Απομόνωση",
        p: "Το ύποπτο άλογο σε καραντίνα αμέσως. Ξεχωριστή φροντίδα, ξεχωριστός εξοπλισμός, αυστηρή υγιεινή. Έλεγχος των υπόλοιπων αλόγων.",
      },
    ],
    faq: [
      {
        q: "Πόσο διαρκεί το στραγγάλωμα;",
        a: "Συνήθως 2–6 εβδομάδες. Ορισμένα άλογα παραμένουν φορείς μέσω των αεροφόρων κόλπων — συνιστάται εξέταση.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
  "zomereczeem": {
    slug: "zomereczeem",
    category: "Παθήσεις",
    title: "Καλοκαιρινό έκζεμα αλόγου — πρόληψη & θεραπεία",
    lead: "Το καλοκαιρινό έκζεμα είναι αλλεργική αντίδραση στο σάλιο των κουνουπιών Culicoides. Διαβάστε για την πρόληψη και τη θεραπεία.",
    datePublished: "2026-05-08",
    sections: [
      {
        h: "Συμπτώματα",
        list: [
          "Κνησμός, ιδιαίτερα στη χαίτη και τη βάση της ουράς",
          "Φαλακρές κηλίδες και κρούστες",
          "Ανησυχία το βράδυ και το πρωί",
        ],
      },
      {
        h: "Πρόληψη",
        list: [
          "Κουβέρτα εκζέματος με κοιλιακό πτερύγιο και κάλυμμα κεφαλής",
          "Στάβλισμα κατά τις ώρες αιχμής (ηλιοβασίλεμα / ανατολή)",
          "Εντομοαπωθητικό προϊόν",
          "Ανεμιστήρας στον στάβλο",
          "Μακριά από υδάτινες επιφάνειες",
        ],
      },
    ],
    faq: [
      {
        q: "Βοηθά η διατροφή ενάντια στο καλοκαιρινό έκζεμα;",
        a: "Ορισμένα συμπληρώματα (ωμέγα-3, βιταμίνη Ε) υποστηρίζουν το δέρμα και το ανοσοποιητικό σύστημα, αλλά δεν το θεραπεύουν.",
      },
    ],
    related: [
      "paarden-gezondheid",
    ],
  },
};

export default KENNISBANK;
